module.exports = __webpack_public_path__ + "assets/others@2x.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/others@2x.jpg
 ** module id = 230
 ** module chunks = 1
 **/